import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private messageService = inject(MessageService);

  success(message: string, summary = 'Éxito'): void {
    this.messageService.add({
      severity: 'success',
      summary,
      detail: message,
      life: 3000,
    });
  }

  error(message: string, summary = 'Error'): void {
    this.messageService.add({
      severity: 'error',
      summary,
      detail: message,
      life: 5000,
    });
  }

  info(message: string, summary = 'Información'): void {
    this.messageService.add({
      severity: 'info',
      summary,
      detail: message,
      life: 3000,
    });
  }

  warn(message: string, summary = 'Advertencia'): void {
    this.messageService.add({
      severity: 'warn',
      summary,
      detail: message,
      life: 4000,
    });
  }

  clear(): void {
    this.messageService.clear();
  }
}
